import React, { useEffect } from 'react';
import authFusionService from '../services/authfusion';

const SilentRenew = () => {
  useEffect(() => {
    authFusionService.userManager.signinSilentCallback().catch((err) => {
      console.error('Silent renew callback error:', err);
    });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand-600 mx-auto mb-3" />
        <p className="text-brand-700">Refreshing session...</p>
      </div>
    </div>
  );
};

export default SilentRenew;
